import { cloneElement, useState } from 'react';
import { cn } from '../../../utils';

import ErrorOrHelp from '../ErrorOrHelp';

type FormItemProps = {
    label?: string;
    className?: string | object;
    error?: string | string[];
    help?: string;
    children: JSX.Element;
};

export type AcceptsSetFormItemError = {
    setFormItemError?: (message: string | undefined) => void;
};

export default function FormItem({
    label,
    error,
    help,
    children,
    className,
    ...rest
}: FormItemProps) {
    const [formItemError, setFormItemError] = useState<string>();
    const childProps = children?.props;
    const child = cloneElement(children, {
        ...childProps,
        error,
        setFormItemError,
    });

    return (
        <div {...rest} className={cn('alli-bg-white', className)}>
            {label && (
                <label
                    htmlFor={childProps.name}
                    className="alli-block alli-text-sm alli-font-medium alli-capitalize alli-leading-6 alli-text-blue-gray-700">
                    {label}
                </label>
            )}

            {child}

            <ErrorOrHelp
                name={childProps.name}
                error={error || formItemError}
                help={help}
            />
        </div>
    );
}
